import * as React from "react";

const styles = require("./TableFromToHeader.pcss");

interface LProps{
    fromTo?: string;
    translation?: string[];
}

export class TableFromToHeader extends React.Component<LProps, {}>{
    constructor(){
        super();
    }

    render(){
        let spanish = this.getTranslationText(this.props.translation);
        return(
            <th className={styles.tHeadFromTo} colSpan={1} rowSpan={2}> { spanish || 'From To' }</th>
        );
    }

    getTranslationText(t){
        let spanishText = '';
        if(t.length == 2)
            spanishText = t[0][3] +' '+ t[1][3];
        return spanishText;
    }
}



// WEBPACK FOOTER //
// ./src/client/Rankia/Components/TableFromToHeader/TableFromToHeader.tsx